import React, { useContext } from 'react'

import { QuizContext } from '@f/applications/QuizApp/context/QuizContext'
import { QUIZ_STEP_TYPES } from '@f/applications/QuizApp/partials/quizConstants'
import { QuizStep } from '@f/applications/QuizApp/partials/types'
import { QuestionBudget } from '@f/applications/QuizApp/questions/QuestionBudget/QuestionBudget'
import { QuestionConstructionMethod } from '@f/applications/QuizApp/questions/QuestionConstructionMethod'
import QuestionDeliveryRegion from '@f/applications/QuizApp/questions/QuestionDeliveryRegion'
import { QuestionEquitySlider } from '@f/applications/QuizApp/questions/QuestionEquitySlider'
import { QuestionFinanceBuyingStage } from '@f/applications/QuizApp/questions/QuestionFinanceBuyingStage'
import { QuestionFinancialDetails } from '@f/applications/QuizApp/questions/QuestionFinancialDetails'
import { QuestionFloorNumber } from '@f/applications/QuizApp/questions/QuestionFloorNumber'
import { QuestionLivingArea } from '@f/applications/QuizApp/questions/QuestionLivingArea'
import { QuestionLoanAmountSlider } from '@f/applications/QuizApp/questions/QuestionLoanAmountSlider'
import { QuestionLoanDetails } from '@f/applications/QuizApp/questions/QuestionLoanDetails/QuestionLoanDetails'
import QuestionObjectAddress from '@f/applications/QuizApp/questions/QuestionObjectAddress/QuestionObjectAddress'
import { QuestionPropertySubtype } from '@f/applications/QuizApp/questions/QuestionPropertySubtype'
import QuestionRadioBarTiles from '@f/applications/QuizApp/questions/QuestionRadio/QuestionRadioBarTiles'
import QuestionRadioCardTiles from '@f/applications/QuizApp/questions/QuestionRadio/QuestionRadioCardTiles'
import QuestionSlider from '@f/applications/QuizApp/questions/QuestionSlider'

import { $TSFixMe } from '@f-fertighaus/applications/UserAccount/interfaces/utils'

import { QuestionExpectedValue } from '../questions/QuestionExpectedValue/QuestionExpectedValue'
import { QuestionFinancialMeans } from '../questions/QuestionFinancialMeans/QuestionFinancialMeans'
import { QuestionHouseholdIncome } from '../questions/QuestionHouseholdIncome'
import { QuestionLivingAndLandArea } from '../questions/QuestionLivingAndLandArea/QuestionLivingAndLandArea'

export const RenderStep = ({ step }: { step: QuizStep }) => {
  const { tileStyle } = useContext(QuizContext) as $TSFixMe

  const RadioStep =
    tileStyle === 'bar' ? (
      <QuestionRadioBarTiles step={step} />
    ) : (
      <QuestionRadioCardTiles step={step} />
    )

  return (
    <>
      {{
        [QUIZ_STEP_TYPES.expansionStage]: RadioStep,
        [QUIZ_STEP_TYPES.houseType]: RadioStep,
        [QUIZ_STEP_TYPES.mfhType]: RadioStep,
        [QUIZ_STEP_TYPES.mfhUsage]: RadioStep,
        [QUIZ_STEP_TYPES.mfhLivingArea]: RadioStep,
        [QUIZ_STEP_TYPES.mfhBudget]: RadioStep,
        [QUIZ_STEP_TYPES.property]: RadioStep,
        [QUIZ_STEP_TYPES.propertyType]: RadioStep,
        [QUIZ_STEP_TYPES.cataloguePreference]: RadioStep,
        [QUIZ_STEP_TYPES.constructionStart]: RadioStep,
        [QUIZ_STEP_TYPES.financingConsultationInterest]: RadioStep,
        [QUIZ_STEP_TYPES.contactPreference]: RadioStep,
        [QUIZ_STEP_TYPES.loanPurpose]: RadioStep,
        [QUIZ_STEP_TYPES.loanDetails]: <QuestionLoanDetails step={step} />,
        [QUIZ_STEP_TYPES.housePurpose]: RadioStep,
        [QUIZ_STEP_TYPES.maritalStatus]: RadioStep,
        [QUIZ_STEP_TYPES.numberOfKids]: RadioStep,
        [QUIZ_STEP_TYPES.occupation]: RadioStep,
        [QUIZ_STEP_TYPES.houseBuyerStage]: RadioStep,
        [QUIZ_STEP_TYPES.customRadio]: RadioStep,
        [QUIZ_STEP_TYPES.valuationInterest]: RadioStep,
        [QUIZ_STEP_TYPES.constructionMethod]: (
          <QuestionConstructionMethod step={step} />
        ),
        [QUIZ_STEP_TYPES.livingAreaTotal]: <QuestionLivingArea step={step} />,
        [QUIZ_STEP_TYPES.financialDetails]: (
          <QuestionFinancialDetails step={step} />
        ),
        [QUIZ_STEP_TYPES.loanAmountSlider]: (
          <QuestionLoanAmountSlider step={step} />
        ),
        [QUIZ_STEP_TYPES.equitySlider]: <QuestionEquitySlider step={step} />,
        [QUIZ_STEP_TYPES.monthlyIncomeSlider]: <QuestionSlider step={step} />,
        [QUIZ_STEP_TYPES.customSlider]: <QuestionSlider step={step} />,
        [QUIZ_STEP_TYPES.budget]: <QuestionBudget step={step} />,
        [QUIZ_STEP_TYPES.deliveryRegion]: (
          <QuestionDeliveryRegion step={step} />
        ),
        [QUIZ_STEP_TYPES.expectedValue]: <QuestionExpectedValue step={step} />,
        [QUIZ_STEP_TYPES.financialMeans]: (
          <QuestionFinancialMeans step={step} />
        ),
        [QUIZ_STEP_TYPES.financeBuyingStage]: (
          <QuestionFinanceBuyingStage step={step} />
        ),
        [QUIZ_STEP_TYPES.householdIncome]: (
          <QuestionHouseholdIncome step={step} />
        ),
        [QUIZ_STEP_TYPES.propertySubtype]: (
          <QuestionPropertySubtype step={step} />
        ),
        [QUIZ_STEP_TYPES.floorNumber]: <QuestionFloorNumber step={step} />,
        [QUIZ_STEP_TYPES.objectAddress]: <QuestionObjectAddress step={step} />,
        [QUIZ_STEP_TYPES.livingAndLandArea]: (
          <QuestionLivingAndLandArea step={step} />
        )
      }[step.type] || null}
    </>
  )
}
